import { ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import { storage } from "./firebase";

/**
 * StorageService
 * Serviço centralizado para manipulação de arquivos no Firebase Storage.
 * Concentra toda a lógica de upload, exclusão e geração de URLs de imagens para evitar peso no Firestore.
 */
class StorageService {
    /**
     * Faz upload de uma string Base64 (Data URL) para um caminho específico no Storage.
     * Retorna a URL pública de download do arquivo.
     * 
     * @param {string} path Caminho completo com extensão (ex: 'tenants/123/members/abc/profile.jpg')
     * @param {string} base64Str String em formato Data URL (data:image/jpeg;base64,...)
     * @returns {Promise<string>} URL de download do arquivo armazenado
     */
    async uploadBase64Image(path, base64Str) {
        if (!base64Str || !base64Str.startsWith('data:image')) {
            throw new Error("Formato Base64 inválido ou vazio.");
        }

        try {
            const fileRef = ref(storage, path);
            // Faz o upload usando 'data_url' que processa nativamente o base64
            await uploadString(fileRef, base64Str, 'data_url');
            // Obtém a URL pública do Firebase Storage
            const downloadUrl = await getDownloadURL(fileRef);
            return downloadUrl;
        } catch (error) {
            console.error("StorageService - Erro no upload da imagem:", error);
            throw error;
        }
    }

    /**
     * Tenta deletar um arquivo do Storage. Ignora o erro silenciosamente se não existir.
     * 
     * @param {string} path Caminho para deletar
     */
    async deleteFileSilently(path) {
        try {
            const fileRef = ref(storage, path);
            await deleteObject(fileRef);
        } catch (error) {
            // Se der erro (ex: object-not-found), silenciamos. O importante é tentar limpar.
        }
    }
}

const storageService = new StorageService();
export default storageService;
